export default {
  lockedBadges: {},
  unlockedBadges: [],
  error: false,
  errorMessage: ""
};